/**
 * ⚠️ DATOS DE EJEMPLO — NO SON REALES ⚠️
 *
 * Todo lo que esta en este archivo esta hardcodeado porque el mockup de la home
 * muestra informacion que hoy NO tiene fuente de datos en ninguna API.
 *
 * Esta todo junto y en un solo lugar a proposito, para que sea evidente que es
 * falso y para poder reemplazarlo dato por dato a medida que aparezcan las
 * fuentes. Si algo de esto se ve en pantalla, no es informacion del cliente.
 *
 * Cada entrada dice que haria falta para volverla real.
 */

export const DATOS_DEMO = {

  // La escalera de niveles y los beneficios por nivel dejaron de ser dato de
  // ejemplo: son reglas reales del Club, distintas por pais, y viven en
  // shared/niveles.ts y shared/beneficios.ts.

  /**
   * Desde cuando el cliente es socio.
   * FUENTE NECESARIA: no hay fecha de alta en ClienteUnicoAppDto. Por eso el
   * pie del sidebar que lo mostraba esta oculto hasta que exista la fecha.
   */
  socioDesde: 'marzo de 2025'

  // Lo que habia acá y se retiro, por si hace falta el historial:
  //  - fechaVencimientoPuntos / ahorroAcumulado / incentivoProximoNivel: la home
  //    ahora calcula los puntos por vencer y el ahorro estimado con datos reales
  //    (historial de fidelidad + compras). Ver resumen-puntos.component.ts.
  //  - mascotas (peso, proxima vacuna): la ficha y las tarjetas usan la API de
  //    Vet real. Ver pet-clinical.service.ts.
  //  - ahorroPorCompra: la columna que lo usaba se quito de Ultimas compras.
};
